import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const auth = () => {
  const stored = localStorage.getItem('admin-auth');
  const token  = stored ? JSON.parse(stored)?.state?.token : null;
  return { headers: { Authorization: `Bearer ${token}` } };
};

// Auto-logout on expired token
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const stored = localStorage.getItem('admin-auth');
      const token  = stored ? JSON.parse(stored)?.state?.token : null;
      if (token) {
        localStorage.removeItem('admin-auth');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const adminApi = {
  getStats:          ()           => axios.get(`${BASE}/admin/stats`, auth()),

  getProducts:       ()           => axios.get(`${BASE}/admin/products`, auth()),
  createProduct:     (data)       => axios.post(`${BASE}/admin/products`, data, auth()),
  updateProduct:     (id, data)   => axios.put(`${BASE}/admin/products/${id}`, data, auth()),
  deleteProduct:     (id)         => axios.delete(`${BASE}/admin/products/${id}`, auth()),
  toggleProductActive:(id)        => axios.put(`${BASE}/admin/products/${id}/toggle-active`, {}, auth()),
  reorderProducts:   (ids)        => axios.put(`${BASE}/admin/products/reorder`, { ids }, auth()),
  getProductVariants:(id)         => axios.get(`${BASE}/admin/products/${id}/variants`, auth()),
  setProductVariants:(id, ids)    => axios.put(`${BASE}/admin/products/${id}/variants`, { variant_ids: ids }, auth()),

  getCategories:     ()           => axios.get(`${BASE}/admin/categories`, auth()),
  createCategory:    (data)       => axios.post(`${BASE}/admin/categories`, data, auth()),
  updateCategory:    (id, data)   => axios.put(`${BASE}/admin/categories/${id}`, data, auth()),
  deleteCategory:    (id)         => axios.delete(`${BASE}/admin/categories/${id}`, auth()),

  getOrders:         ()           => axios.get(`${BASE}/admin/orders`, auth()),
  createOrder:       (data)       => axios.post(`${BASE}/admin/orders`, data, auth()),
  getOrder:          (id)         => axios.get(`${BASE}/admin/orders/${id}`, auth()),
  updateOrder:       (id, data)   => axios.put(`${BASE}/admin/orders/${id}`, data, auth()),
  updateOrderItems:  (id, data)   => axios.put(`${BASE}/admin/orders/${id}/items`, data, auth()),
  duplicateOrder:    (id)         => axios.post(`${BASE}/admin/orders/${id}/duplicate`, {}, auth()),
  updateOrderStatus: (id, status) => axios.put(`${BASE}/admin/orders/${id}/status?status=${status}`, {}, auth()),
  bulkMarkPaid:      (ids)        => axios.post(`${BASE}/admin/orders/bulk-paid`, { ids }, auth()),
  getCNSlips:        (cns)        => axios.post(`${BASE}/admin/orders/cn-slips`, { cns }, auth()),
  getOrderTracking:  (id)         => axios.get(`${BASE}/admin/orders/${id}/tracking`, auth()),
  getOrderComments:  (id)         => axios.get(`${BASE}/admin/orders/${id}/comments`, auth()),
  addOrderComment:   (id, data)   => axios.post(`${BASE}/admin/orders/${id}/comments`, data, auth()),
  updateOrderComment:(id, cid, data) => axios.put(`${BASE}/admin/orders/${id}/comments/${cid}`, data, auth()),
  deleteOrderComment:(id, cid)    => axios.delete(`${BASE}/admin/orders/${id}/comments/${cid}`, auth()),
  bookPostex:        (payload)         => axios.post(`${BASE}/admin/orders/book-postex`, payload, auth()),
  getCCCities:       ()               => axios.get(`${BASE}/admin/callcourier/cities`, auth()),
  getCCAreas:        (cityId)         => axios.get(`${BASE}/admin/callcourier/areas?city_id=${cityId}`, auth()),

  syncTracking:      ()           => axios.post(`${BASE}/admin/sync-tracking?force=true`, {}, auth()),
  trackByCN:         (cn)         => axios.get(`${BASE}/admin/track?cn=${encodeURIComponent(cn)}`, auth()),

  getUsers:          ()           => axios.get(`${BASE}/admin/users`, auth()),
  toggleUser:        (id)         => axios.put(`${BASE}/admin/users/${id}/toggle`, {}, auth()),

  // Image upload
  uploadImage: (file, type = 'product') => {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${BASE}/admin/upload?type=${type}`, form, {
      headers: { ...auth().headers, 'Content-Type': 'multipart/form-data' },
    });
  },

  // Store Settings
  getStoreSettings:  ()           => axios.get(`${BASE}/store/settings`, { params: { _t: Date.now() } }),
  saveStoreSettings: (data)       => axios.put(`${BASE}/admin/store/settings`, data, auth()),

  // Banners
  getBanners:        ()           => axios.get(`${BASE}/admin/store/banners`, auth()),
  createBanner:      (data)       => axios.post(`${BASE}/admin/store/banners`, data, auth()),
  updateBanner:      (id, data)   => axios.put(`${BASE}/admin/store/banners/${id}`, data, auth()),
  deleteBanner:      (id)         => axios.delete(`${BASE}/admin/store/banners/${id}`, auth()),
  toggleFeatured:    (id)         => axios.put(`${BASE}/admin/store/products/${id}/featured`, {}, auth()),
  getStoreProducts:  ()           => axios.get(`${BASE}/admin/products`, auth()),
  getStoreCategories:()           => axios.get(`${BASE}/admin/categories`, auth()),

  // Courier Settings
  getCourierSettings:   ()          => axios.get(`${BASE}/admin/courier/settings`, auth()),
  saveCourierSettings:  (key, data) => axios.put(`${BASE}/admin/courier/settings/${key}`, data, auth()),
  testCourierConnection:(key)       => axios.post(`${BASE}/admin/courier/test/${key}`, {}, auth()),

  updateCredentials: (data) => axios.put(`${BASE}/admin/credentials`, data, auth()),

  // Reviews
  getReviews:     (approved) => axios.get(`${BASE}/admin/reviews`, { ...auth(), params: approved !== undefined ? { approved } : {} }),
  approveReview:  (id)       => axios.put(`${BASE}/admin/reviews/${id}/approve`, {}, auth()),
  rejectReview:   (id)       => axios.put(`${BASE}/admin/reviews/${id}/reject`, {}, auth()),
  deleteReview:   (id)       => axios.delete(`${BASE}/admin/reviews/${id}`, auth()),
};
